module.exports = __webpack_public_path__ + "media/images/front/icons/info-3b70b2dbac72f005b8fd7dc0e178566c.svg";